import IFlowModelForUser from '@Shared.Angular/@types/core/contracts/queryModel/flows/flowModelForUser';
import { Guid } from '@Shared.Angular/@types/guid';
import { Services } from '@Shared.Angular/@types/services';
import angular, { IPromise } from 'angular';

angular
  .module('flowingly.services')
  .factory('flowinglyApiService', flowinglyApiService);

flowinglyApiService.$inject = ['$http', 'APP_CONFIG'];

function flowinglyApiService(
  $http: angular.IHttpService,
  APP_CONFIG: Services.APP_CONFIG
) {
  //API
  const service = {
    getFlowModelsReferencingComponent: getFlowModelsReferencingComponent,
    updateFlowModelsReferencingComponent: updateFlowModelsReferencingComponent
  };

  return service;

  function getFlowModelsReferencingComponent(
    flowModelId: Guid
  ): IPromise<IFlowModelForUser[]> {
    return $http
      .get<IFlowModelForUser[]>(
        APP_CONFIG.apiBaseUrl +
          `workflow/getFlowModelsReferencingComponent/${flowModelId}`,
        { noSpinner: false }
      )
      .then((response) => {
        return response.data;
      });
  }

  function updateFlowModelsReferencingComponent(flowModelId) {
    return $http
      .post<unknown>(
        APP_CONFIG.apiBaseUrl +
          `workflow/updateFlowModelsReferencingComponent/${flowModelId}`,
        { noSpinner: true }
      )
      .then(function (response) {
        return response.data;
      });
  }
}

export type FlowinglyApiServiceType = ReturnType<typeof flowinglyApiService>;
